import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import SelectInputTranslated from 'components/layout/forms/SelectInputTranslated';
import translations from 'services/translations/translations';
import { APPROVED, OPEN } from 'services/enums/offers/Statuses';
import { fetchStatusTypes } from 'store/offers/actions';

const Status = ({
  formState,
  handleFormState,
  initialStatus,
  sent,
}: {
  formState: { status: string };
  handleFormState: any;
  initialStatus: null | string;
  sent: boolean;
}): JSX.Element => {
  const { t } = useTranslation([translations.offers]);

  const dispatch = useDispatch();
  const statusTypes = useSelector((state: any) => state.offers.statusTypes);

  useEffect(() => {
    dispatch(fetchStatusTypes());
  }, []);

  const offerIsApproved = initialStatus === APPROVED;

  // A sent offer cannot be reopened, a new revision has to be created instead
  const options = sent
    ? statusTypes.filter((statusType: string) => statusType !== OPEN)
    : statusTypes;

  return (
    <SelectInputTranslated
      disabled={offerIsApproved}
      key="status"
      label={t(`${translations.offers}:Status`)}
      name="status"
      onChange={handleFormState}
      options={options}
      required
      translationPath={`${translations.offers}:statuses`}
      value={formState.status}
    />
  );
};

export default Status;
